export const add = (array, item) => {
  if (!array.includes(item)) array.push(item);
};

export const areSetsEqual = (a, b) => a.size === b.size && [...a].every((value) => b.has(value));
